<template>
  <div>
    <SearchToolbar
      class="mb-6"
      :placeholder="$t('Rechercher par nom, prénom ou email du client')"
      :available-filters="filters"
      :selected-filters="currentFilteringData"
      :initial-keywords="currentFilteringData.keywords"
      @update-filter-search="updateCurrentFilteringData"
      @update-keyword-search="updateKeywordSearch"
    />
    <div v-if="leads.length === 0" class="text-center mt-4 py-2">
      <p>Aucun devis</p>
    </div>
    <Table v-else :columns="columns" :data="formattedData">
      <template #subscriptionLink="{ row }">
        <div class="flex gap-x-2">
          <a :href="row.subscriptionLink" class="text-primary underline" target="_blank">{{ row.subscriptionLink }}</a>
          <ClipboardIcon class="cursor-pointer w-4 h-4 text-gray-300" @click="copyToClipboard(row.subscriptionLink)" />
        </div>
      </template>
    </Table>
    <Pagination :currentPage="currentPage" :totalPages="totalPages" :totalCount="totalCount" @changePage="fetchLeads" />
  </div>
</template>

<script>
import { Pagination, SearchToolbar, Table, toCamelCase } from "@estaly/ui";
import { ClipboardIcon } from "@heroicons/vue/solid";
import LeadsService from "@/api/services/leads";

export default {
  components: { Pagination, SearchToolbar, Table, ClipboardIcon },
  props: {
    storeId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      leads: [],
      currentPage: 1,
      totalPages: null,
      totalCount: null,
      currentFilteringData: {
        keywords: null,
        status: [],
      },
      filters: {
        status: [],
      },
    };
  },
  computed: {
    formattedData() {
      return this.leads.map((lead) => ({
        purchaseDate: lead.purchaseDate,
        customerFullName: `${lead.customer.firstName} ${lead.customer.lastName}`,
        customerEmail: lead.customer.email,
        categoryLabel: this.$t(`contract_distributions.category.${lead.categoryId}`),
        status: lead.status,
        subscriptionLink: lead.subscriptionLink,
      }));
    },
    columns() {
      const res = [
        { label: "Date", field: "purchaseDate" },
        { label: "Client", field: "customerFullName" },
        { label: "Email", field: "customerEmail" },
        { label: "Formule", field: "categoryLabel" },
        {
          label: "Statut",
          field: "status",
          class: {
            live: "p-1 rounded-lg bg-yellow-50 text-yellow-600",
            expired: "p-1 rounded-lg bg-gray-50 text-gray-600",
            converted: "p-1 rounded-lg bg-green-50 text-green-600",
            waiting_for_confirmation: "p-1 rounded-lg bg-blue-50 text-blue-600",
            payment_intent_failed: "p-1 rounded-lg bg-red-50 text-red-600",
          },
        },
        { label: "Lien", field: "subscriptionLink", slot: "subscriptionLink" },
      ];
      return res;
    },
  },
  created() {
    this.fetchLeads();
  },
  watch: {
    storeId() {
      this.fetchLeads();
    },
  },
  methods: {
    copyToClipboard(subscriptionLink) {
      navigator.clipboard.writeText(subscriptionLink);
    },
    updateCurrentFilteringData(filterName, filterOptions) {
      this.currentFilteringData[filterName] = filterOptions;
      this.fetchLeads();
    },
    updateKeywordSearch(keywords) {
      this.currentFilteringData["keywords"] = keywords;
      this.fetchLeads();
    },
    async fetchLeads(page = 1) {
      const params = {
        page,
        store: [this.storeId],
        type: ["lead"],
        keywords: this.currentFilteringData.keywords,
        status: this.currentFilteringData.status,
      };
      const response = await LeadsService.fetchIndex(params);
      if (!response?.success) return;

      const data = toCamelCase(response.data);
      this.leads = data.leads;
      this.filters = data.filters;
      this.totalCount = data.page.totalCount;
      this.totalPages = data.page.totalPages;
      this.currentPage = data.page.currentPage;
    },
  },
};
</script>
